import { EnvVariables } from './types';

export const ProdEnvVariables: EnvVariables = {
  backendUri: 'https://dashboard.ipractice.nl/api/',
  auth: {
    clientId: 'bd964716-3ca0-4bd2-bcde-af2ed7be5d56',
    authFlow: {
      flowName: 'B2C_1A_PASSWORDLESSSIGNUPORSIGNIN',
      authority:
        'https://ipracticeproduction.b2clogin.com/ipracticeproduction.onmicrosoft.com/B2C_1A_PASSWORDLESSSIGNUPORSIGNIN',
    },
    knownAuthority: 'ipracticeproduction.b2clogin.com',
    backendAuthScope: 'https://ipracticeproduction.onmicrosoft.com/backendapi/user_access',
  },
  streamKey: 'rzgwe48gpxej',
  applicationInsightsConnectionString:
    'InstrumentationKey=b37a541c-1872-4383-8b39-71df7c337d9c;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=af4abe96-9aaa-4d87-94e5-69a32e3a2b3f',
};
